var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TaskCardHeader"},[_c('TaskTitle',{attrs:{"isCardExpanded":_vm.isCardExpanded,"task":_vm.taskComputed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }